import { useRipple } from '../../hook/useRipple';

interface IButton {
  type: 'submit' | 'delete' | 'update' | 'reset' | 'excel';
  text: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  style?: React.CSSProperties;
}

/**
 * @author taulmax
 * @date 2024.10.08
 * @description 버튼 컴포넌트
 */
const Button = ({ type, text, onClick, disabled, style }: IButton) => {
  const { ripples, createRipple } = useRipple();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!disabled) {
      createRipple(e);
      onClick(e);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`saju_button ${type}`}
      disabled={disabled}
      style={style}
    >
      {text}
      {ripples.map(ripple => (
        <span key={ripple.id} className="ripple" style={ripple.style} />
      ))}
    </button>
  );
};

export default Button;
